import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mdl-filter-accounts',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './mdl-filter-accounts.html',
  styleUrl: './mdl-filter-accounts.css'
})
export class MdlFilterAccounts implements OnInit {
  constructor(
    public mdl: MatDialogRef<MdlFilterAccounts>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data && data.cuentas) {
      this.extractFilterOptions(data.cuentas);
    }
    if (data && data.filters) {
      this.filters = { ...this.filters, ...data.filters };
    }
  }

  availableOwners: string[] = [];
  availableTypes: string[] = [];

  filters = {
    allOwners: true,
    allTypes: true,
    creationDateRange: 'all',
    phoneFilter: 'all',
    owners: {} as { [key: string]: boolean },
    types: {} as { [key: string]: boolean }
  };

  ngOnInit() {
    this.initializeCheckboxes();
  }

  private extractFilterOptions(cuentas: any[]): void {
    
    const ownersSet = new Set<string>();
    const typesSet = new Set<string>();

    cuentas.forEach(cuenta => {
      if (cuenta.ejecutivo) {
        const ownerName = `${cuenta.ejecutivo.nombre} ${cuenta.ejecutivo.apellido}`.trim();
        if (ownerName) {
          ownersSet.add(ownerName);
        }
      }
      
      if (cuenta.tipo_cuenta) {
        typesSet.add(cuenta.tipo_cuenta);
      }
    });

    this.availableOwners = Array.from(ownersSet).sort();
    this.availableTypes = Array.from(typesSet).sort();
  }

  private initializeCheckboxes(): void {
    this.availableOwners.forEach(owner => {
      if (this.filters.owners[owner] === undefined) {
        this.filters.owners[owner] = this.filters.allOwners;
      }
    });

    this.availableTypes.forEach(type => {
      if (this.filters.types[type] === undefined) {
        this.filters.types[type] = this.filters.allTypes;
      }
    });
  }

  toggleAllOwners(): void {
    if (this.filters.allOwners) {
      this.availableOwners.forEach(owner => {
        this.filters.owners[owner] = true;
      });
    } else {
      this.availableOwners.forEach(owner => {
        this.filters.owners[owner] = false;
      });
    }
  }

  onOwnerChange(): void {
    const allOwnersSelected = this.availableOwners.every(owner => this.filters.owners[owner]);
    const anyOwnerSelected = this.availableOwners.some(owner => this.filters.owners[owner]);
    
    this.filters.allOwners = allOwnersSelected;
    
    if (!anyOwnerSelected) {
      this.filters.allOwners = true;
      this.toggleAllOwners();
    }
  }

  toggleAllTypes(): void {
    if (this.filters.allTypes) {
      this.availableTypes.forEach(type => {
        this.filters.types[type] = true;
      });
    } else {
      this.availableTypes.forEach(type => {
        this.filters.types[type] = false;
      });
    }
  }

  onTypeChange(): void {
    const allTypesSelected = this.availableTypes.every(type => this.filters.types[type]);
    const anyTypeSelected = this.availableTypes.some(type => this.filters.types[type]);
    
    this.filters.allTypes = allTypesSelected;
    
    if (!anyTypeSelected) {
      this.filters.allTypes = true;
      this.toggleAllTypes();
    }
  }

  clearFilters(): void {
    this.filters = {
      allOwners: true,
      allTypes: true,
      creationDateRange: 'all',
      phoneFilter: 'all',
      owners: {},
      types: {}
    };
    
    this.initializeCheckboxes();
  }

  closeMdl(): void {
    this.mdl.close();
  }

  applyFilters(): void {
    this.mdl.close(this.filters);
  }
}